var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodeJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#58a745",
    d: "M 245.5,1.5 C 246.209,0.596028 247.209,0.262695 248.5,0.5C 251.167,0.5 253.833,0.5 256.5,0.5C 256.833,168.667 256.5,336.667 255.5,504.5C 252.5,499.167 249.5,493.833 246.5,488.5C 247.167,407.501 247.5,326.334 247.5,245C 247.5,163.497 246.833,82.3306 245.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#55a445",
    d: "M 256.5,0.5 C 258.467,0.260572 260.301,0.593906 262,1.5C 270.111,15.3929 277.944,29.3929 285.5,43.5C 285.167,195.001 285.5,346.334 286.5,497.5C 278.796,502.685 270.796,507.352 262.5,511.5C 261.167,511.5 259.833,511.5 258.5,511.5C 257.773,509.046 256.773,506.713 255.5,504.5C 256.5,336.667 256.833,168.667 256.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5aab46",
    d: "M 245.5,1.5 C 246.833,82.3306 247.5,163.497 247.5,245C 247.5,326.334 247.167,407.501 246.5,488.5C 233.821,465.14 221.154,441.806 208.5,418.5C 209.167,352.834 209.5,287.001 209.5,221C 209.497,154.624 208.83,88.4573 207.5,22.5C 219.872,14.9803 232.539,7.98029 245.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5fb147",
    d: "M 207.5,22.5 C 208.83,88.4573 209.497,154.624 209.5,221C 209.5,287.001 209.167,352.834 208.5,418.5C 193.44,392.092 178.773,365.425 164.5,338.5C 165.167,290.334 165.5,242.001 165.5,193.5C 165.5,144.829 164.833,96.4954 163.5,48.5C 177.801,39.3441 192.468,30.6775 207.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#509d43",
    d: "M 336.5,42.5 C 350.834,49.9976 364.834,57.9976 378.5,66.5C 376.972,66.5173 376.472,67.184 377,68.5C 401.052,100.218 424.719,132.218 448,164.5C 448.671,165.252 449.504,165.586 450.5,165.5C 447.531,171.777 444.198,177.777 440.5,183.5C 438.983,183.489 437.816,182.823 437,181.5C 402.955,135.244 368.789,89.0776 334.5,43C 335.094,42.5357 335.761,42.369 336.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52a144",
    d: "M 285.5,43.5 C 292.268,53.3663 298.268,63.6996 303.5,74.5C 303.167,212.334 303.5,350.001 304.5,487.5C 298.83,491.337 292.83,494.67 286.5,497.5C 285.5,346.334 285.167,195.001 285.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#65b849",
    d: "M 163.5,48.5 C 164.833,96.4954 165.5,144.829 165.5,193.5C 165.5,242.001 165.167,290.334 164.5,338.5C 148.167,309.167 131.833,279.833 115.5,250.5C 112.101,243.369 108.434,236.369 104.5,229.5C 105.833,180.5 105.833,131.5 104.5,82.5C 123.669,70.412 143.335,59.0787 163.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#52a144",
    d: "M 378.5,66.5 C 408.779,83.6428 439.112,100.809 469.5,118C 471.766,119.426 473.432,121.26 474.5,123.5C 466.009,137.139 458.009,151.139 450.5,165.5C 449.504,165.586 448.671,165.252 448,164.5C 424.719,132.218 401.052,100.218 377,68.5C 376.472,67.184 376.972,66.5173 378.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#509e43",
    d: "M 303.5,74.5 C 308.478,81.7747 312.978,89.4413 317,97.5C 316.835,224.837 317.668,351.837 319.5,478.5C 314.767,481.89 309.767,484.89 304.5,487.5C 303.5,350.001 303.167,212.334 303.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#68bd4a",
    d: "M 104.5,82.5 C 105.833,131.5 105.833,180.5 104.5,229.5C 96.1977,213.888 87.531,198.555 78.5,183.5C 67.2576,161.343 55.2576,139.676 42.5,118.5C 62.5036,105.493 83.1703,93.4934 104.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c9942",
    d: "M 248.5,0.5 C 248.5,0.166667 248.5,-0.166667 248.5,-0.5C 253.167,-0.5 257.833,-0.5 262.5,-0.5C 287.462,13.3147 312.129,27.6481 336.5,42.5C 335.761,42.369 335.094,42.5357 334.5,43C 368.789,89.0776 402.955,135.244 437,181.5C 437.816,182.823 438.983,183.489 440.5,183.5C 433.5,196.833 426.5,210.167 419.5,223.5C 417.744,225.249 416.411,227.249 415.5,229.5C 386.444,191.08 357.611,152.413 329,113.5C 328.346,112.304 327.846,112.304 327.5,113.5C 335.197,126.229 342.363,139.229 349,152.5C 349.495,255.804 349.662,358.804 349.5,461.5C 339.833,467.669 329.833,473.336 319.5,478.5C 317.668,351.837 316.835,224.837 317,97.5C 312.978,89.4413 308.478,81.7747 303.5,74.5C 298.268,63.6996 292.268,53.3663 285.5,43.5C 277.944,29.3929 270.111,15.3929 262,1.5C 260.301,0.593906 258.467,0.260572 256.5,0.5C 253.833,0.5 251.167,0.5 248.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#489341",
    d: "M 415.5,229.5 C 412.658,235.857 409.325,241.857 405.5,247.5C 397.692,234.564 389.859,221.564 382,208.5C 381.167,286.169 381.333,363.835 382.5,441.5C 383.417,440.873 384.417,440.539 385.5,440.5C 373.836,448.001 361.836,455.001 349.5,461.5C 349.662,358.804 349.495,255.804 349,152.5C 342.363,139.229 335.197,126.229 327.5,113.5C 327.846,112.304 328.346,112.304 329,113.5C 357.611,152.413 386.444,191.08 415.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#3f8f3b",
    d: "M 42.5,118.5 C 55.2576,139.676 67.2576,161.343 78.5,183.5C 62.4955,175.831 46.4955,168.164 30.5,160.5C 30.3335,151.161 30.5002,141.827 31,132.5C 32.8657,126.142 36.699,121.475 42.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#3e9339",
    d: "M 30.5,160.5 C 46.4955,168.164 62.4955,175.831 78.5,183.5C 87.531,198.555 96.1977,213.888 104.5,229.5C 108.434,236.369 112.101,243.369 115.5,250.5C 112.833,254.5 110.167,258.5 107.5,262.5C 82.0217,249.595 56.355,236.928 30.5,224.5C 30.5,203.167 30.5,181.833 30.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#3f883e",
    d: "M 474.5,123.5 C 477.294,125.819 479.128,128.819 480,132.5C 480.5,185.499 480.667,238.499 480.5,291.5C 479.669,279.007 479.169,266.34 479,253.5C 459.152,243.327 439.319,233.327 419.5,223.5C 426.5,210.167 433.5,196.833 440.5,183.5C 444.198,177.777 447.531,171.777 450.5,165.5C 458.009,151.139 466.009,137.139 474.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#438c40",
    d: "M 405.5,247.5 C 406.897,251.06 408.897,254.227 411.5,257C 410.944,257.383 410.611,257.883 410.5,258.5C 410.168,314.336 410.501,370.002 411.5,425.5C 403.168,431.002 394.501,436.002 385.5,440.5C 384.417,440.539 383.417,440.873 382.5,441.5C 381.333,363.835 381.167,286.169 382,208.5C 389.859,221.564 397.692,234.564 405.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#3e9836",
    d: "M 30.5,224.5 C 56.355,236.928 82.0217,249.595 107.5,262.5C 99.4041,277.033 91.0708,291.366 82.5,305.5C 82.719,304.325 82.3857,303.325 81.5,302.5C 64.5964,293.881 47.5964,285.548 30.5,277.5C 30.5,259.833 30.5,242.167 30.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#3f8b3c",
    d: "M 419.5,223.5 C 439.319,233.327 459.152,243.327 479,253.5C 479.169,266.34 479.669,279.007 480.5,291.5C 480.5,319.5 480.5,347.5 480.5,375.5C 461.733,345.856 443.899,315.523 427,284.5C 421.725,275.6 416.225,266.933 410.5,258.5C 410.611,257.883 410.944,257.383 411.5,257C 408.897,254.227 406.897,251.06 405.5,247.5C 409.325,241.857 412.658,235.857 415.5,229.5C 416.411,227.249 417.744,225.249 419.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f873e",
    d: "M 115.5,250.5 C 131.833,279.833 148.167,309.167 164.5,338.5C 178.773,365.425 193.44,392.092 208.5,418.5C 221.154,441.806 233.821,465.14 246.5,488.5C 249.5,493.833 252.5,499.167 255.5,504.5C 256.773,506.713 257.773,509.046 258.5,511.5C 255.167,511.5 251.833,511.5 248.5,511.5C 179.595,472.041 110.595,432.541 41.5,393C 38.6141,391.615 36.6141,389.449 35.5,386.5C 45.0981,370.302 54.4314,353.969 63.5,337.5C 70.3223,327.199 76.6556,316.533 82.5,305.5C 91.0708,291.366 99.4041,277.033 107.5,262.5C 110.167,258.5 112.833,254.5 115.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#3f873e",
    d: "M 410.5,258.5 C 416.225,266.933 421.725,275.6 427,284.5C 443.899,315.523 461.733,345.856 480.5,375.5C 479.642,381.049 477.309,385.883 473.5,390C 452.941,402.11 432.275,413.943 411.5,425.5C 410.501,370.002 410.168,314.336 410.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#3d9f33",
    d: "M 30.5,277.5 C 47.5964,285.548 64.5964,293.881 81.5,302.5C 82.3857,303.325 82.719,304.325 82.5,305.5C 76.6556,316.533 70.3223,327.199 63.5,337.5C 63.0919,336.357 62.4252,335.357 61.5,334.5C 51.0181,329.759 40.6848,324.759 30.5,319.5C 30.5,305.5 30.5,291.5 30.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#3da52f",
    d: "M 30.5,319.5 C 40.6848,324.759 51.0181,329.759 61.5,334.5C 62.4252,335.357 63.0919,336.357 63.5,337.5C 54.4314,353.969 45.0981,370.302 35.5,386.5C 33.2542,384.351 31.7542,381.684 31,378.5C 30.5,358.836 30.3334,339.169 30.5,319.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/nodeJS.01106261d76bfc405e5467493fcc9339.svg";
export { ForwardRef as ReactComponent };